import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "navigation"
    }}>{`Navigation`}</h1>
    <p>{`Describes basic methods for navigating within an extension.`}</p>
    <h2 {...{
      "id": "api-to-open-content-fragment-from-an-extension"
    }}>{`API to open Content Fragment from an extension`}</h2>
    <p>{`Default editor for your organization will be used to open Content Fragment.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useEffect } from "react";
import { Text } from "@adobe/react-spectrum"
import { extensionId } from "./Constants"
import { register } from "@adobe/uix-guest";

function ExtensionRegistration() {
    useEffect(() => {
        const init = async () => {
            const registrationConfig = {
                id: extensionId,
                methods: {
                    actionBar: {
                        getButtons() {
                            return [
                                {
                                    id: "example.open_in_editor",
                                    label: "UIX Open In Editor",
                                    icon: 'Export',
                                    variant: "primary",
                                    onClick: (selections) => {
                                        console.log("UIX Open In Editor has been pressed.");
                                        console.log(selections[0].id);
                                        // or any other content fragment path
                                        
                                        guestConnection.host.navigation.openEditor(selections[0].id);
                                    },
                                },
                            ];
                        },
                    },
                },
            };
            const guestConnection = await register(registrationConfig);
        }
        init().catch(console.error)
    }, []);
    return <Text>IFrame for integration with Host (AEM)...</Text>
}

export default ExtensionRegistration;
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "29.062500000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/0e5ccff228af617c89713849ac841b1a/5530d/navigation.admin.open_in_editor.webp 320w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/0c8fb/navigation.admin.open_in_editor.webp 640w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/94b1e/navigation.admin.open_in_editor.webp 1280w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/0b34d/navigation.admin.open_in_editor.webp 1920w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/a5062/navigation.admin.open_in_editor.webp 2478w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/0e5ccff228af617c89713849ac841b1a/dd4a7/navigation.admin.open_in_editor.png 320w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/0f09e/navigation.admin.open_in_editor.png 640w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/bbbf7/navigation.admin.open_in_editor.png 1280w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/ac7a9/navigation.admin.open_in_editor.png 1920w", "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/9c596/navigation.admin.open_in_editor.png 2478w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/0e5ccff228af617c89713849ac841b1a/bbbf7/navigation.admin.open_in_editor.png",
            "alt": "navigation admin open in editor",
            "title": "navigation admin open in editor",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`API Reference`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fragmentPath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The path of the CF to be open.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      